import * as s from "./WidgetStyled";

import { WidthProvider, Layout, Responsive } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import * as mediaQuery from "components/MediaQuery";
import AddLayout from "./AddLayout";
import EXPAND_HANDLE from "assets/icons/expand.svg";
import {
  DashbaordAlertSendMessage,
  DashboarAlertLatest,
} from "api/interfaces/dashboardInterface.interface";
import CardItem, { CardItemName } from "./item/card/CardItem";
import TableItem from "./item/table/TableItem";
import {
  WidgetCardData,
  WidgetCardResult,
} from "api/interfaces/widgetInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import * as cc from "pages/dashboard/stats/ChartControlStyled";
import { RiCloseLine, RiDragMove2Fill } from "react-icons/ri";
import {
  AssignModalType,
  normalizeLayoutMinSize,
  TableItemName,
} from "utils/WidgetUtil";

const ResponsiveReactGridLayout = WidthProvider(Responsive);
interface Props {
  cardLayout: Layout[] | undefined;
  chartLayout: Layout[] | undefined;
  isAddModal: boolean;
  isLoading: boolean;
  rowHeight: number;
  isAssignModal: AssignModalType;
  assignInfo: { [key: string]: string };
  selectedAlertItem: DashbaordAlertSendMessage;
  onAddLayout: (type?: string, newItem?: string[]) => void;
  onCardLayoutChange: (layout: Layout[]) => void;
  onTableLayoutChange: (layout: Layout[]) => void;
  onDeleteWidget: (key: TableItemName | TableItemName[]) => void;
  onAssignModal: (type: string) => void;
  onSelectItem: (item: DashboarAlertLatest) => void;
  cardData: WidgetCardData;
  onViewDetailCard: (key: CardItemName) => void;
  isDetailView: CardItemName | null;
  isEnabled: boolean;
  isDraggable: boolean;
  onToggleDraggable: (isDraggable: boolean, isSave?: boolean) => void;
}

export default function WidgetPresenter(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const isDesktop = mediaQuery.useIsDesktop();
  return props.isLoading ||
    props.cardLayout === undefined ||
    props.chartLayout === undefined ? (
    <></>
  ) : (
    <>
      <s.Container as="section">
        {props.cardLayout !== null && (
          <s.SummaryGrid>
            <ResponsiveReactGridLayout
              autoSize
              className="layout"
              // cols={8}
              // layout={props.layout}
              isDraggable={isDesktop && props.isEnabled}
              breakpoints={{
                lg: mediaQuery.tabletMax,
                md: mediaQuery.mobileMin,
                sm: 0,
              }}
              cols={{ lg: 4, md: 2, sm: 1 }}
              layouts={{
                lg: normalizeLayoutMinSize(props.cardLayout, 4),
                md: normalizeLayoutMinSize(
                  props.cardLayout.map((l, index) => ({
                    ...l,
                    x: index % 2 === 0 ? 1 : 0,
                    y: index > 2 ? 1 : 0,
                  })),
                  2
                ),
                sm: normalizeLayoutMinSize(props.cardLayout, 1),
              }}
              preventCollision={false}
              compactType={"horizontal"}
              isResizable={false}
              rowHeight={200}
              margin={[20, 20]}
              containerPadding={[0, 0]}
              // draggableCancel={".drag-cancel-content"}
              draggableHandle=".drag-handle"
              isBounded={true}
              onDragStop={props.onCardLayoutChange}
            >
              {props.cardLayout.map((l, index) => {
                return (
                  <s.SummaryGridItem key={l.i}>
                    <CardItem
                      name={l.i as CardItemName}
                      cardData={
                        props.cardData[l.i as CardItemName] as WidgetCardResult
                      }
                      isDetailView={props.isDetailView === l.i}
                      onView={() => props.onViewDetailCard(l.i as CardItemName)}
                    />
                  </s.SummaryGridItem>
                );
              })}
            </ResponsiveReactGridLayout>
          </s.SummaryGrid>
        )}

        {props.chartLayout !== undefined && props.isEnabled && (
          <s.ChartGrid isDraggable={props.isDraggable}>
            <ResponsiveReactGridLayout
              autoSize
              className="layout"
              // cols={8}
              // layout={props.layout}
              breakpoints={{
                lg: mediaQuery.tabletMax,
                sm: mediaQuery.mobileMax,
                xs: 0,
              }}
              isDraggable={props.isDraggable}
              cols={{ lg: 2, sm: 1, xs: 1 }}
              compactType="horizontal"
              preventCollision={false}
              isBounded={true}
              layouts={{
                lg: normalizeLayoutMinSize(props.chartLayout, 2),
                sm: normalizeLayoutMinSize(props.chartLayout, 1),
                xs: normalizeLayoutMinSize(props.chartLayout, 1),
              }}
              resizeHandle={
                <span className="react-resizable-handle react-resizable-handle-se">
                  <img src={EXPAND_HANDLE} alt="expand handle icon" />
                </span>
              }
              onDragStop={(layout) => {
                // 차트 위젯만 반영 (Summary 카드 제외)
                const chartLayout = layout.filter(
                  (item) => !item.i.includes("Count")
                );
                // chartLayout을 기반으로 업데이트하되, props.cardLayouts에 없는 항목도 포함
                const updatedMap = new Map(
                  props.chartLayout?.map((item) => [item.i, item]) ?? []
                );
                chartLayout.forEach((item) => {
                  updatedMap.set(item.i, item);
                });
                // y → x 순으로 정렬해 빈 공간을 채운 뒤 순서대로 따라오는 시각적 순서 유지
                const sorted = Array.from(updatedMap.values()).sort((a, b) => {
                  if (a.x !== b.x) return a.x - b.x;
                  return a.y - b.y;
                });
                props.onTableLayoutChange(sorted);
              }}
              onResizeStop={props.onTableLayoutChange}
              rowHeight={400}
              margin={[20, 20]}
              containerPadding={[0, 0]}
              draggableCancel={".drag-cancel-content"}
            >
              {props.chartLayout !== undefined &&
                props.chartLayout.map((l: Layout) => {
                  return (
                    <s.SummaryGridItem key={l.i}>
                      <TableItem
                        key={`table-item-${l.i}`}
                        layout={l}
                        chartLayout={props.chartLayout ?? []}
                        onLayoutChange={props.onTableLayoutChange}
                        onDeleteWidget={props.onDeleteWidget}
                      />
                    </s.SummaryGridItem>
                  );
                })}
            </ResponsiveReactGridLayout>
          </s.ChartGrid>
        )}
      </s.Container>
      {isDesktop &&
        props.isEnabled &&
        props.chartLayout !== undefined &&
        !selectedAccount.isHidden && (
          <cc.FlowButtonWrapper>
            <AddLayout
              layouts={props.chartLayout}
              isAddModal={props.isAddModal}
              onAddLayout={props.onAddLayout}
              onDeleteWidget={props.onDeleteWidget}
            />

            <cc.FlowButton
              onClick={() => props.onToggleDraggable(!props.isDraggable)}
              data-testid="dashboard-dashboard-dashboard-flow-button-toggle-draggable"
            >
              {props.isDraggable ? (
                <RiCloseLine size={20} />
              ) : (
                <RiDragMove2Fill size={20} />
              )}
            </cc.FlowButton>
          </cc.FlowButtonWrapper>
        )}
    </>
  );
}
